module.exports = __webpack_public_path__ + "img/ticket-simple.cd9bc6a2.svg";